import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Search from '../views/Search.vue'
import UnderConstruction from '../views/UnderConstruction.vue'
import todo from '../views/todo.vue'
import changeLog from '../views/changeLog.vue'
import supporters from '../views/Supporters.vue'
import contact from '../views/contact.vue'
import simpleSissy from '../views/sissyRoulettes/simpleSissy.vue'
import sissySelfie from '../views/sissyRoulettes/sissySelfie.vue'
import sissyWeekend from '../views/sissyRoulettes/sissyWeekend.vue'
import shavingRoulette from '../views/sissyRoulettes/shavingRoulette.vue'
import analDomme from '../views/analRoulettes/analDomme.vue'
import tspornroulette from '../views/genRoulettes/tspornroulette.vue'
import celebBracket from '../views/genRoulettes/celebBracket.vue'
import playmateBracket from '../views/genRoulettes/playmateBracket.vue'
import cbtwheel from '../views/genRoulettes/cbtWheel.vue'
import transformationMaze from '../views/games/transformationMaze.vue'
import fapCards from '../views/games/fapCards.vue'
import sissyBingo from '../views/games/sissyBingo.vue'
import poker from '../views/games/poker.vue'
import chastityMemory from '../views/games/chastityMemory.vue'
import nanobotTrial from '../views/games/nanobotTrial.vue'
import battleCards from '../views/games/battleCards/battleCards.vue'
import battleCardsDeckBuilder from '../views/games/battleCards/battleCardsDeckBuilder.vue'
import battleCardsBuyPacks from '../views/games/battleCards/battleCardsBuyPacks.vue'
import battleCardsPlay from '../views/games/battleCards/battleCardsPlay.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/search',
    name: 'Search',
    component: Search
  },
  {
    path: '/todo',
    name: 'todo',
    component: todo
  },
  {
    path: '/changelog',
    name: 'changeLog',
    component: changeLog
  },
  {
    path: '/supporters',
    name: 'supporters',
    component: supporters
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/simplesissy',
    name: 'simpleSissy',
    component: simpleSissy
  },
  {
    path: '/sissyselfie',
    name: 'sissySelfie',
    component: sissySelfie
  },
  {
    path: '/sissyweekend',
    name: 'sissyWeekend',
    component: sissyWeekend
  },
  {
    path: '/shavingroulette',
    name: 'shavingRoulette',
    component: shavingRoulette
  },
  {
    path: '/analdomme',
    name: 'analDomme',
    component: analDomme
  },
  {
    path: '/tspornroulette',
    name: 'tspornroulette',
    component: tspornroulette
  },
  {
    path: '/celebBracket',
    name: 'celebBracket',
    component: celebBracket
  },
  {
    path: '/playmateBracket',
    name: 'playmateBracket',
    component: playmateBracket
  },
  {
    path: '/transformationMaze',
    name: 'transformationMaze',
    component: transformationMaze
  },
  {
    path: '/fapCards',
    name: 'fapCards',
    component: fapCards
  },
  {
    path: '/sissyBingo',
    name: 'sissyBingo',
    component: sissyBingo
  },
  {
    path: '/poker',
    name: 'poker',
    component: poker
  },
  {
    path: '/chastityMemory',
    name: 'chastityMemory',
    component: chastityMemory
  },
  {
    path: '/nanobotTrial',
    name: 'nanobotTrial',
    component: nanobotTrial
  },
  {
    path: '/battleCards',
    name: 'battleCards',
    component: battleCards
  },
  {
    path: '/battleCardsDeckBuilder',
    name: 'battleCardsDeckBuilder',
    component: battleCardsDeckBuilder
  },
  {
    path: '/battleCardsBuyPacks',
    name: 'battleCardsBuyPacks',
    component: battleCardsBuyPacks
  },
  {
    path: '/battleCardsPlay',
    name: 'battleCardsPlay',
    component: battleCardsPlay
  },
    {
    path: '/cbtwheel',
    name: 'cbtwheel',
    component: cbtwheel
  },
  {
    path :'*',
    component:UnderConstruction
  }
]

const router = new VueRouter({
  routes
})

export default router
